module.exports = __webpack_public_path__ + "static/media/projectManagement.277773f6.png";